import Loadable from 'react-loadable';

import store from '@swf/core/store';

const YodaApp = Loadable({
  loader: async () => {
    const { default: template } = await import(
      /* webpackChunkName: "tools" */ './src/models/template'
    );
    store.addModel(template);
    return import(/* webpackChunkName: "tools" */ './src/components/YodaApp/YodaApp');
  },
  loading: () => null
});

const KenobiApp = Loadable({
  loader: async () => {
    const { default: template } = await import(
      /* webpackChunkName: "tools" */ './src/models/template'
    );
    store.addModel(template);
    return import(/* webpackChunkName: "tools" */ './src/components/KenobiApp/KenobiApp');
  },
  loading: () => null
});

export { YodaApp, KenobiApp };
